<template>
  <!-- 获奖名单 -->
  <div class="News bg-round bg-fff">
    <div class="container" id="w-1200px">
      <Bread :list="breadList" class="ma-t-10" />
      <div class="">
        <div class="flex ma-tb-30">
          <div class="c-p" :class="type==0?'bold':''" @click="type=0;loadDataList()">全部</div>
          <div class="c-p" :class="type==1?'bold ma-l-20':'ma-l-20'" @click="type=1;loadDataList()">
            2022-2023
          </div>
          <div class="c-p" :class="type==2?'bold ma-l-20':'ma-l-20'" @click="type=2;loadDataList()">
            2023-2024
          </div>
          <div class="c-p ma-l-20"   @click="$router.push({path:'/winnerList/index'})">所有获奖名单 / List of winners</div>

        </div>
        <div class="width100 pa-r-20" v-for="(item1, index1) in dataList" :key="index1">
          <div >
            <div class="fon-20 t-center bold ma-t-20">{{item1.Title}}</div>
            <div class="fon-18 t-center c-red">{{item1.SubTitle}} </div>
            <div class="ma-t-20 flex f-wrap">
            <div class="ma-b-20 c-p listma-r"
              v-for="(item, index) in item1.List" :key="index" @click="toDetail(item.Id)">
              <img
                :src="item.Image"
                alt=""
                class="img_contain b-r-15"
                width="100%"
                height="280"
              />
              <div class="flex flex-direction f-between flex1 t-center">
                <div>
                  <div class="ma-t-10">
                  {{ item.VideoName }}
                  </div>
                  <div class="ma-t-10">
                  {{ item.Director }}
                  </div>
                <div class="ma-t-10">
                 {{ item.PrizeName }}
                </div>
                </div>
                <div class="ma-t-10 c-666 flex f-between f-center">
                  <div>{{ item.ReleaseTime }}</div>
                </div>
              </div>
              </div>
            </div>
          </div>
          <Empty :isShow="!dataList || dataList.length==0"></Empty>
          <div class="fy t-center">
            <el-pagination
              @current-change="handleCurrentChange"
              :hide-on-single-page="true"
              :current-page.sync="pageIndex"
              :page-size="pageSize"
              layout="prev, pager, next, jumper"
              :total="totals"
            ></el-pagination>
          </div>
        </div>
         
      </div>
    </div>
  </div>
</template>

<script>
  import { getAwardVideo,getTimeAwardVideo } from "../api.js";
  export default {
    data() {
      return {
        breadList: [
          {
            name: "获奖作品",
            path: "/winnerList/index",
          },
        ],
        categoryId: "5087154684770997611",
        pageIndex:1,
        pageSize:100000,
        categoryList: [],
        dataList: [],
        hotList: [],
        totals: 0,
        timeList:[],
        type:0,
      };
    },
    created() {
      if(this.$route.query.categoryId){
        this.categoryId=this.$route.query.categoryId
      }
      this.loadData();
      this.loadDataList();

    },
    methods: {
      loadData() {
        getTimeAwardVideo().then((res) => {
          if (res.data.Code == 0) {
            this.timeList = res.data.Data;
          }
        });
      },
      loadDataList(type) {
        if (type == "refresh") {
          this.pageIndex = 1;
        }
        getAwardVideo({
          pageIndex: this.pageIndex,
          pageSize: this.pageSize,
          type: this.type,
        }).then((res) => {
          if (res.data.Code == 0) {
            this.dataList = res.data.Data.List;
            this.totals = res.data.Data.TotalCount;
          }
        });
      },
      toDetail(id) {
        console.log(id)
        //this.$router.push({ path: "/news/detail", query: { id: id } });
      },
      // 当前页改变时触发
      handleCurrentChange(e) {
        this.pageIndex = e;
        this.loadDataList();
      },
    },
  };
</script>

<style lang="scss" scoped>
  .listma-r{
    width:22%;
    margin-right:calc(12%/4);
  }
  .listma-r:nth-child(4n){
    margin-right:0;
  }
  .News .container {
    min-height: 1150px;
    // background: #ffffff;
    box-sizing: border-box;
    padding: 30px 40px;
  }

  .tab-active {
    border-bottom: 4px solid #fb004d;
    color: #fb004d;
    font-weight: bold;
  }

  .menu-item {
    position: relative;

    .item-right {
      position: absolute;
      right: 0;
      top: 0;
    }

    .item-left {
      position: absolute;
      left: 0;
      top: 0;
    }
  }
  .box-top {
    width: 30px;
    height: 30px;
    text-align: center;
    line-height: 30px;
  }
  .bg-topOther {
    background: #bfbfbf;
  }
  .bg-top1 {
    background: #f9014b;
  }
  .bg-top2 {
    background: #eb6100;
  }
  .bg-top3 {
    background: #f8b551;
  }
</style>